import { BrowserRouter, Routes, Route } from "react-router-dom";

import Layout from "./shared/Layout";
import Home from "./routes/Home";
import About from "./routes/About";
import Projects from "./routes/Projects";

import { BubblyContainer } from "./library/src";
import Preloader from "./components/Preloader";

export default function App() {
  return (
    <BrowserRouter>
      <Preloader />
      <BubblyContainer />
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="about" element={<About />} />
          <Route path="projects" element={<Projects />} />
          <Route path="*" element={<Home />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
